import {Box, Container, Typography, useTheme} from '@mui/material'
import hero1 from '../assets/hero-1.png'
import hero2 from '../assets/hero-2.png'
import hero3 from '../assets/hero-3.png'
import hero4 from '../assets/hero-4.png'
import SearchBox from './SearchBox'
import {useTranslation} from 'react-i18next'

const HeroSection = () => {
  const theme = useTheme()
  const [t] = useTranslation()

  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          textAlign: 'center',
          position: 'relative',
          paddingTop: {xs: 4, sm: 6, lg: 8},
          paddingBottom: {xs: 20, sm: 25, lg: 30}
        }}
      >
        {/* Floating blured images */}
        <Box
          sx={{
            position: 'absolute',
            top: {xs: '5%', lg: '49%'},
            left: {xs: '-4%', sm: '2%', md: '18%', lg: '-3%'},
            zIndex: 1,
            width: {xs: 55, sm: 75, lg: 95},
            height: 'auto'
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 80,
              height: 80,
              borderRadius: '50%',
              backgroundColor: '#61F1FD',
              filter: 'blur(80px)',
              zIndex: -1
            }}
          />
          <Box
            component="img"
            src={hero1}
            sx={{width: '100%', transform: 'rotate(0deg)'}}
          />
        </Box>
        <Box
          sx={{
            position: 'absolute',
            bottom: {xs: '-8%', md: '-12%', lg: '-8%'},
            left: {xs: '-10%', sm: '0%', lg: '12%'},
            zIndex: 1,
            width: {xs: 200, sm: 250, md: 315}
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: {xs: 80, lg: 150},
              height: 'auto',
              aspectRatio: '1/1',
              borderRadius: '50%',
              backgroundColor: '#61F1FD',
              filter: 'blur(100px)',
              zIndex: -1
            }}
          />
          <Box component="img" src={hero2} sx={{width: '100%'}} />
        </Box>
        <Box
          sx={{
            position: 'absolute',
            bottom: {xs: '5%', lg: '10%'},
            right: {xs: '0%', sm: '8%', lg: '17%'},
            zIndex: 1,
            width: {xs: 105, sm: 180, md: 200}
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: {xs: 80, lg: 150},
              height: 'auto',
              aspectRatio: '1/1',
              borderRadius: '50%',
              backgroundColor: '#61F1FD',
              filter: 'blur(100px)',
              zIndex: -1
            }}
          />
          <Box component="img" src={hero3} sx={{width: '100%'}} />
        </Box>
        <Box
          sx={{
            position: 'absolute',
            top: {xs: '28%', md: '40%', lg: '46%'},
            right: {xs: '5%', lg: '5%'},
            zIndex: 1,
            width: {xs: 50, sm: 100, md: 110}
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: {xs: 40, md: 90},
              aspectRatio: '1/1',
              height: 'auto',
              borderRadius: '50%',
              backgroundColor: '#61F1FD',
              filter: 'blur(80px)',
              zIndex: -1
            }}
          />
          <Box
            component="img"
            src={hero4}
            sx={{width: '100%', transform: 'rotate(0deg)'}}
          />
        </Box>

        {/* Hero text */}
        <Typography
          sx={{
            color: theme.palette.grey[900],
            fontWeight: 400,
            fontFamily: 'Vancober, Varela Round',
            fontSize: {xs: '60px', sm: '80px', md: '100px', lg: '130px'},
            letterSpacing: {xs: '-4px', lg: '-6px'},
            lineHeight: 0.9,
            wordSpacing: {xs: '6px', md: '8px', xl: '10px'},
            zIndex: 5
          }}
        >
          {t('fnd-home-hero-title-1')}
          <br />
          <Box component="span">{t('fnd-home-hero-title-2')}</Box>
          <Box
            component="span"
            sx={{
              fontWeight: 400,
              background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              display: 'inline-block'
            }}
          >
            AI
          </Box>{' '}
          {t('fnd-home-hero-title-3')}
        </Typography>

        {/* Subtitle */}
        <Typography
          sx={{
            mt: 3,
            color: theme.palette.grey[900],
            fontWeight: 500,
            fontSize: {xs: 14, sm: 18},
            fontFamily: 'Inter, Varela Round'
          }}
        >
          {t('fnd-home-hero-subtitle')}
        </Typography>

        {/* Search */}
        <SearchBox />
      </Box>
    </Container>
  )
}

export default HeroSection
